import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { Chart } from 'chart.js/auto';
import 'chartjs-adapter-moment';

import { AlertService } from '../../services/alert.service';
import { PairingService } from '../../services/pairing.service';
import { PersonalService } from '../../services/personal.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';
import { TrackingService } from '../../services/tracking.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'user-v1',
    templateUrl: './user-v1.component.html',
    styleUrls: ['./user-v1.component.scss']
})
export class UserV1Component implements OnInit, OnDestroy {

    @Input()
    accountId!: string;

    unknownAccountId!: boolean;

    account_detail: any;

    personal: any;

    context: any;

    accountDetailFormGroup!: FormGroup;

    personalFormGroup!: FormGroup;

    devices!: any[] | null;

    applications!: any[] | null;

    trackingDistance!: Chart | null;

    trackingSteps!: Chart | null;

    trackingCalories!: Chart | null;

    trackingDuration!: Chart | null;

    trackingDistanceWeek!: Chart | null;

    trackingStepsWeek!: Chart | null;

    trackingCaloriesWeek!: Chart | null;

    trackingDurationWeek!: Chart | null;

    heartRateYearChart!: Chart | null;

    heartRateWeekChart!: Chart | null;

    sleepChart!: Chart | null;

    sleepWeekChart!: Chart | null;

    showModal!: string | null;

    confirmValidateUrl!: string;

    confirmResetUrl!: string;

    hoverEmailStatus!: boolean;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private userService: UserService,
        private personalService: PersonalService,
        private pairingService: PairingService,
        private trackingService: TrackingService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {

        this.accountDetailFormGroup = this.formBuilder.group({
            accountDetailEmailInput: [{ value: null, disabled: false }, /*Validators.required*/],
            accountDetailFirstNameInput: [{ value: null, disabled: false }, Validators.required],
            accountDetailLastNameInput: [{ value: null, disabled: false }, Validators.required],
            accountDetailLocaleInput: [{ value: null, disabled: false }, Validators.required],
            accountDetailTimeZoneInput: [{ value: null, disabled: false }, Validators.required],
            accountDetailRoleInput: [{ value: null, disabled: false }, Validators.required]
        });

        this.personalFormGroup = this.formBuilder.group({
            personalNickNameInput: [{ value: null, disabled: false }, Validators.required],
            personalGenderInput: [{ value: null, disabled: false }, Validators.required],
            personalCountryInput: [{ value: null, disabled: false }, Validators.required],
            personalDateOfBirthInput: [{ value: null, disabled: false }, Validators.required],
            personalHeightInput: [{ value: null, disabled: false }, Validators.required],
            personalHeightUnitInput: [{ value: null, disabled: false }, Validators.required],
            personalWeightInput: [{ value: null, disabled: false }, Validators.required],
            personalWeightUnitInput: [{ value: null, disabled: false }, Validators.required]
        });

        this.getUserInfo();
        this.updateJwtContext();
        this.loadDevices();
    }

    ngOnDestroy() {
    }

    getUserInfo() {

        let accountId: string = this.accountId.trim();
        this.account_detail = null;
        this.personal = null;

        this.progressIndicatorService.progress = true;
        this.userService.searchByAccountId(accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.getUserInfo.userService.searchByAccountId.value', value);
                this.progressIndicatorService.progress = false;

                let account_detail: any = value.account_detail;

                this.progressIndicatorService.progress = true;
                this.personalService.getFullPersonalAvatarByAccountId(accountId).subscribe({
                    next: (value: any) => {
                        console.log('UserComponentV1.getUserInfo.personalService.getFullPersonalAvatarByAccountId.value', value);
                        this.progressIndicatorService.progress = false;

                        let personal: any = value.personal || {};
                        personal.avatar = value.avatar;

                        this.applyAccountAndPersonalData(account_detail, personal);
                    },
                    error: (error: any) => {
                        console.log('UserComponentV1.getUserInfo.personalService.getFullPersonalAvatarByAccountId.error', error);
                        this.progressIndicatorService.progress = false;

                        if (error.status == 404) {

                            let personal: any = {};
                            personal.avatar = value.avatar;

                            this.applyAccountAndPersonalData(account_detail, personal);

                        } else {
                            this.alertService.danger('Error');
                        }
                    }
                });
            },
            error: (error: any) => {
                console.log('UserComponentV1.getUserInfo.userService.searchByAccountId.error', error);
                this.progressIndicatorService.progress = false;

                if (error.status == 404) {
                    this.unknownAccountId = true;
                } else {
                    this.alertService.danger('Error');
                }
            }
        });
    }

    applyAccountAndPersonalData(account_detail: any, personal: any) {

        this.accountDetailFormGroup.controls['accountDetailEmailInput'].patchValue(account_detail.email);
        this.accountDetailFormGroup.controls['accountDetailFirstNameInput'].patchValue(account_detail.first_name);
        this.accountDetailFormGroup.controls['accountDetailLastNameInput'].patchValue(account_detail.last_name);
        this.accountDetailFormGroup.controls['accountDetailLocaleInput'].patchValue(account_detail.locale);
        this.accountDetailFormGroup.controls['accountDetailTimeZoneInput'].patchValue(account_detail.tz);
        this.accountDetailFormGroup.controls['accountDetailRoleInput'].patchValue(account_detail.role);

        this.personalFormGroup.controls['personalNickNameInput'].patchValue(personal.nickname);
        this.personalFormGroup.controls['personalGenderInput'].patchValue(personal.gender);
        this.personalFormGroup.controls['personalCountryInput'].patchValue(personal.country);
        this.personalFormGroup.controls['personalDateOfBirthInput'].patchValue(personal.dateOfBirth);
        this.personalFormGroup.controls['personalHeightInput'].patchValue(personal.height);
        this.personalFormGroup.controls['personalHeightUnitInput'].patchValue(personal.heightUnit);
        this.personalFormGroup.controls['personalWeightInput'].patchValue(personal.weight);
        this.personalFormGroup.controls['personalWeightUnitInput'].patchValue(personal.weightUnit);

        this.account_detail = account_detail;
        this.personal = personal;
    }

    updateJwtContext() {

        let accountId: string = this.accountId.trim();
        this.context = null;

        //this.progressIndicatorService.progress = true;
        this.userService.getJwtByAccountId(accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.updateJwtContext.userService.getJwtByAccountId.value', value);
                this.progressIndicatorService.progress = false;
                this.context = value.context;
            },
            error: (error: any) => {
                console.log('UserComponentV1.updateJwtContext.userService.getJwtByAccountId.error', error);
                //this.progressIndicatorService.progress = false;
                //this.alertService.danger('Error');
            }
        });
    }

    saveAccountDetail() {

        let formGroup: FormGroup = this.accountDetailFormGroup;

        let accountDetail: any = {};
        accountDetail.accountId = this.account_detail.account_id;
        accountDetail.email = formGroup.value.accountDetailEmailInput;
        accountDetail.firstName = formGroup.value.accountDetailFirstNameInput;
        accountDetail.lastName = formGroup.value.accountDetailLastNameInput;
        accountDetail.locale = formGroup.value.accountDetailLocaleInput;
        accountDetail.timeZone = formGroup.value.accountDetailTimeZoneInput;
        accountDetail.role = formGroup.value.accountDetailRoleInput;

        this.progressIndicatorService.progress = true;
        this.userService.updateAccountDetailByAccountId(accountDetail).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.saveAccountDetail.userService.updateAccountDetailByAccountId.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.getUserInfo();
                this.updateJwtContext();
            },
            error: (error: any) => {
                console.log('UserComponentV1.saveAccountDetail.userService.updateAccountDetailByAccountId.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.getUserInfo();
                this.updateJwtContext();
            }
        });
    }

    savePersonalInfo() {

        let formGroup: FormGroup = this.personalFormGroup;

        let personalInfo: any = {};
        personalInfo.nickname = formGroup.value.personalNickNameInput;
        personalInfo.gender = formGroup.value.personalGenderInput;
        personalInfo.country = formGroup.value.personalCountryInput;
        personalInfo.dateOfBirth = formGroup.value.personalDateOfBirthInput;
        personalInfo.height = formGroup.value.personalHeightInput;
        personalInfo.heightUnit = formGroup.value.personalHeightUnitInput;
        personalInfo.weight = formGroup.value.personalWeightInput;
        personalInfo.weightUnit = formGroup.value.personalWeightUnitInput;

        this.progressIndicatorService.progress = true;
        this.userService.updatePersonalInfoByAccountId(this.accountId, personalInfo).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.savePersonalInfo.userService.updatePersonalInfoByAccountId.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.getUserInfo();
            },
            error: (error: any) => {
                console.log('UserComponentV1.savePersonalInfo.userService.updatePersonalInfoByAccountId.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
                this.getUserInfo();
            }
        });
    }

    loadDevices() {

        this.devices = null;
        this.applications = null;

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.pairingService.getAllDevicesByAccountId(this.accountId),
            this.pairingService.getAllApplicationsByAccountId(this.accountId),
        ]).subscribe({
            next: ([devices, applications]) => {
                console.log('UserComponentV1.loadDevices.pairingService.getAllDevicesByAccountId.devices', devices);
                console.log('UserComponentV1.loadDevices.pairingService.getAllApplicationsByAccountId.applications', applications);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                this.devices = devices.sort((a: any, b: any) => b.lastPairing - a.lastPairing);
                this.applications = applications.sort((a: any, b: any) => b.lastUpdate - a.lastUpdate);

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadDevices.pairingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadTrackingData() {

        [this.trackingSteps, this.trackingDistance, this.trackingCalories, this.trackingDuration,
        this.trackingStepsWeek, this.trackingDistanceWeek, this.trackingCaloriesWeek, this.trackingDurationWeek]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any, backgroundColor: string, label: string, displayTitle: boolean) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    label: label,
                    maxBarThickness: 2,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: displayTitle,
                        text: 'Year View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                        grid: {
                            offset: false
                        },
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getLastYearTrackingData(this.accountId),
            this.trackingService.getLastYearHourlyTrackingDataByActivity('DURATION', this.accountId),
        ]).subscribe({
            next: ([trackingData, durationData]) => {
                console.log('UserComponentV1.loadTrackingData.trackingService.getLastYearTrackingData.value', trackingData);
                console.log('UserComponentV1.loadTrackingData.trackingService.getLastYearHourlyTrackingDataByActivity.value', durationData);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let trackingDistanceData = trackingData.filter((item: any) => item.activity == 'DISTANCE').map((item: any) => ({ x: new Date(item.date), y: item.value }));
                let trackingStepsData = trackingData.filter((item: any) => item.activity == 'STEPS').map((item: any) => ({ x: new Date(item.date), y: item.value }));
                let trackingCaloriesData = trackingData.filter((item: any) => item.activity == 'CAL').map((item: any) => ({ x: new Date(item.date), y: item.value }));
                //let trackingDurationData = trackingData.filter((item: any) => item.activity == 'DURATION').map((item: any) => ({ x: new Date(item.date), y: item.value }));

                let trackingDurationData = durationData
                    .map((item: any) => {
                        let x: Date = new Date(item.day);
                        let y: number = item.hours.reduce((a: number, b: number) => a + b, 0);
                        if (item.hours.filter((value: number) => value > 0).length > 1 && item.hours.filter((value: number) => value > 60).length == 0) {
                            y *= 60;
                        }
                        return { x: x, y: y };
                    })
                    .filter((item: any) => item.y > 0);

                this.trackingDistance = createChart('trackingDistance', trackingDistanceData, '#009933', 'DISTANCE (meters)', false);
                this.trackingSteps = createChart('trackingSteps', trackingStepsData, '#FFCC00', 'STEPS (steps)', true);
                this.trackingCalories = createChart('trackingCalories', trackingCaloriesData, '#990000', 'CALORIES (calories)', false);
                this.trackingDuration = createChart('trackingDuration', trackingDurationData, '#003399', 'DURATION (seconds)', false);

                this.loadTrackingWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadTrackingData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    trackingStepsClick(event: any) {
        this.trackingDataChartClick(this.trackingSteps?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDistanceClick(event: any) {
        this.trackingDataChartClick(this.trackingDistance?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingCaloriesClick(event: any) {
        this.trackingDataChartClick(this.trackingCalories?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDurationClick(event: any) {
        this.trackingDataChartClick(this.trackingDuration?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingStepsWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingStepsWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDistanceWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingDistanceWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingCaloriesWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingCaloriesWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDurationWeekClick(event: any) {
        this.trackingDataChartClick(this.trackingDurationWeek?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    trackingDataChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.trackingStepsWeek?.destroy();
            this.trackingDistanceWeek?.destroy();
            this.trackingCaloriesWeek?.destroy();
            this.trackingDurationWeek?.destroy();
            this.trackingStepsWeek = null;
            this.trackingDistanceWeek = null;
            this.trackingCaloriesWeek = null;
            this.trackingDurationWeek = null;
            this.loadTrackingWeekData(date);
        }
    }

    loadTrackingWeekData(date: Date) {

        [this.trackingStepsWeek, this.trackingDistanceWeek, this.trackingCaloriesWeek, this.trackingDurationWeek]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let fromDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d.setDate(d.getDate() + 7);
        let toDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let minDate: string = fromDate;

        d.setDate(d.getDate() - 1);
        let maxDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let createChart = (id: string, data: any, backgroundColor: string, label: string, displayTitle: boolean) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    label: label,
                    maxBarThickness: 5,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: displayTitle,
                        text: 'Week View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: minDate + 'T00:00:00.000',
                        max: maxDate + 'T23:59:59.999',
                        grid: {
                            offset: false
                        },
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getWeeklyHourTrackingDataByActivity('DISTANCE', this.accountId, fromDate, toDate),
            this.trackingService.getWeeklyHourTrackingDataByActivity('STEPS', this.accountId, fromDate, toDate),
            this.trackingService.getWeeklyHourTrackingDataByActivity('CAL', this.accountId, fromDate, toDate),
            this.trackingService.getWeeklyHourTrackingDataByActivity('DURATION', this.accountId, fromDate, toDate),
        ]).subscribe({
            next: ([distance, steps, calories, duration]) => {
                console.log('UserComponentV1.loadTrackingWeekData.trackingService.getWeeklyHourTrackingDataByActivity.distance', distance);
                console.log('UserComponentV1.loadTrackingWeekData.trackingService.getWeeklyHourTrackingDataByActivity.steps', steps);
                console.log('UserComponentV1.loadTrackingWeekData.trackingService.getWeeklyHourTrackingDataByActivity.calories', calories);
                console.log('UserComponentV1.loadTrackingWeekData.trackingService.getWeeklyHourTrackingDataByActivity.duration', duration);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let trackingDistanceData: any[] = [];
                let trackingStepsData: any[] = [];
                let trackingCaloriesData: any[] = [];
                let trackingDurationData: any[] = [];

                let convert = (input: any, output: any[], durationfix = false) => {
                    let data: any;
                    for (data of Array.from(input)) {
                        let coeff = 1;
                        if (durationfix && data.hours.filter((value: number) => value > 0).length > 1 && data.hours.filter((value: number) => value > 60).length == 0) {
                            coeff = 60;
                        }
                        for (let i = 0; i < data.hours.length; i++) {
                            let date: Date = new Date(Date.parse(data.day));
                            date.setHours(i);
                            date.setMinutes(0);
                            let x: Date = date;
                            let y: number = data.hours[i] * coeff;
                            let point = { x: x, y: y };
                            output.push(point);
                        }
                    }
                };

                convert(distance, trackingDistanceData);
                convert(steps, trackingStepsData);
                convert(calories, trackingCaloriesData);
                convert(duration, trackingDurationData, true);

                this.trackingDistanceWeek = createChart('trackingDistanceWeek', trackingDistanceData, '#009933', 'DISTANCE (meters)', false);
                this.trackingStepsWeek = createChart('trackingStepsWeek', trackingStepsData, '#FFCC00', 'STEPS (steps)', true);
                this.trackingCaloriesWeek = createChart('trackingCaloriesWeek', trackingCaloriesData, '#990000', 'CALORIES (calories)', false);
                this.trackingDurationWeek = createChart('trackingDurationWeek', trackingDurationData, '#003399', 'DURATION (seconds)', false);

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadHeartRateData() {

        [this.heartRateYearChart, this.heartRateWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Year View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getLastYearHeartRateData(this.accountId),
        ]).subscribe({
            next: ([heartRateData]) => {
                console.log('UserComponentV1.loadHeartRateData.trackingService.getLastYearHeartRateData.value', heartRateData);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let heartRateYearData = heartRateData.map((item: any) => ({ x: new Date(item.date), y: item.value }))
                    .filter((item: any) => item.y > 0);

                this.heartRateYearChart = createChart('heartRateYearChart', heartRateYearData, '#990000', 'HEARTRATE (bpm)');

                this.loadHeartRateWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadHeartRateData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    heartRateYearChartClick(event: any) {
        this.heartRateChartClick(this.heartRateYearChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    heartRateWeekChartClick(event: any) {
        this.heartRateChartClick(this.heartRateWeekChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    heartRateChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.heartRateWeekChart?.destroy();
            this.heartRateWeekChart = null;
            this.loadHeartRateWeekData(date);
        }
    }

    loadHeartRateWeekData(date: Date) {

        [this.heartRateWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let days: string[] = [];
        for (let i = 0; i < 7; i++) {
            days[i] = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;
            d.setDate(d.getDate() + 1);
        }

        let createChart = (id: string, data: any, backgroundColor: string, label: string) => new Chart(id, {
            type: 'line',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: backgroundColor,
                    borderColor: backgroundColor,
                    label: label,
                    showLine: false,
                    fill: false,
                    pointStyle: 'cross',
                    pointBackgroundColor: backgroundColor,
                    pointBorderColor: backgroundColor,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Week View',
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: days[0] + 'T00:00:00.000',
                        max: days[6] + 'T23:59:59.999',
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        }
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[0]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[1]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[2]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[3]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[4]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[5]),
            this.trackingService.getDailyMinuteHeartRateData(this.accountId, days[6]),
        ]).subscribe({
            next: ([day0, day1, day2, day3, day4, day5, day6]) => {
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day0);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day1);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day2);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day3);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day4);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day5);
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.getDailyMinuteHeartRateData.value', day6);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let heartRateWeekData = [];
                for (let day of [day0, day1, day2, day3, day4, day5, day6]) {
                    for (let minute of day.minute) {
                        let date: Date = new Date(Date.parse(day.day));
                        date.setHours(0);
                        date.setMinutes(minute.minute);
                        let x: Date = date;
                        let y: number = minute.value;
                        let point = { x: x, y: y };
                        heartRateWeekData.push(point);
                    }
                }
                heartRateWeekData = heartRateWeekData.sort((a, b) => a.x.getTime() - b.x.getTime());

                this.heartRateWeekChart = createChart('heartRateWeekChart', heartRateWeekData, '#990000', 'HEARTRATE (bpm)');

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadHeartRateWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    loadSleepData() {

        [this.sleepChart, this.sleepWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(Date.now());
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        d.setMonth(d.getMonth() + 1);
        let maxDate: Date = new Date(d);
        d.setMonth(d.getMonth() - 12);
        let minDate: Date = new Date(d);

        let createChart = (id: string, data: any) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data.map((item: any) => ({ x: item.x, y: item.y.deepDuration })),
                    backgroundColor: '#2077a2',
                    label: 'DEEP (minutes)',
                    maxBarThickness: 2
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.lightDuration })),
                    backgroundColor: '#29a5e5',
                    label: 'LIGHT (minutes)',
                    maxBarThickness: 2
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.awakeDuration })),
                    backgroundColor: '#d270c3',
                    label: 'AWAKE (minutes)',
                    maxBarThickness: 2
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Year View',
                    },
                    tooltip: {
                        mode: 'x'
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'YYYY MMM'
                            },
                            tooltipFormat: 'YYYY-MM-DD',
                            unit: 'month',
                        },
                        min: minDate + '',
                        max: maxDate + '',
                        grid: {
                            offset: false
                        },
                        stacked: true,
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        },
                        stacked: true,
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getLastYearSleepData(this.accountId),
        ]).subscribe({
            next: ([sleepData]) => {
                console.log('UserComponentV1.loadSleepData.trackingService.getLastYearSleepData.value', sleepData);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let data: any = {};
                for (let sleep of sleepData) {
                    if (!data[sleep.endTime]) {
                        data[sleep.endTime] = { deepDuration: 0, lightDuration: 0, awakeDuration: 0 };
                    }
                    data[sleep.endTime].date = new Date(Date.parse(sleep.endTime));
                    data[sleep.endTime].deepDuration += sleep.deepDuration;
                    data[sleep.endTime].lightDuration += sleep.lightDuration;
                    data[sleep.endTime].awakeDuration += sleep.awakeDuration;
                }

                sleepData = [];
                for (let sleep in data) {
                    sleepData.push({ x: data[sleep].date, y: { deepDuration: data[sleep].deepDuration, lightDuration: data[sleep].lightDuration, awakeDuration: data[sleep].awakeDuration } });
                }
                sleepData = sleepData.sort((a: any, b: any) => a.x.getTime() - b.x.getTime());

                this.sleepChart = createChart('sleepChart', sleepData);

                this.loadSleepWeekData(new Date(Date.now()));

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadSleepData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    sleepYearChartClick(event: any) {
        this.sleepChartClick(this.sleepChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    sleepWeekChartClick(event: any) {
        this.sleepChartClick(this.sleepWeekChart?.getElementsAtEventForMode(event, 'nearest', {}, true));
    }

    sleepChartClick(elements: any) {
        if (elements.length > 0) {
            let date: Date = elements[0].element.$context.raw.x;
            this.sleepWeekChart?.destroy();
            this.sleepWeekChart = null;
            this.loadSleepWeekData(date);
        }
    }

    loadSleepWeekData(date: Date) {

        [this.sleepWeekChart]
            .filter(chart => chart != null)
            .forEach(chart => chart?.destroy());

        let d: Date = new Date(date);
        d = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        d.setDate(d.getDate() - 3);

        let pad = (s: number, n: number) => '0'.repeat(n).concat(s.toString()).slice(-Math.max(n, s.toString().length));

        let fromDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        d.setDate(d.getDate() + 7);
        let toDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let minDate: string = fromDate;

        d.setDate(d.getDate() - 1);
        let maxDate: string = `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1, 2)}-${pad(d.getDate(), 2)}`;

        let createChart = (id: string, data: any) => new Chart(id, {
            type: 'bar',
            data: {
                datasets: [{
                    data: data.map((item: any) => ({ x: item.x, y: item.y.deepDuration })),
                    backgroundColor: '#2077a2',
                    label: 'DEEP (minutes)',
                    maxBarThickness: 5,
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.lightDuration })),
                    backgroundColor: '#29a5e5',
                    label: 'LIGHT (minutes)',
                    maxBarThickness: 5,
                },
                {
                    data: data.map((item: any) => ({ x: item.x, y: item.y.awakeDuration })),
                    backgroundColor: '#d270c3',
                    label: 'AWAKE (minutes)',
                    maxBarThickness: 5,
                }]
            },
            options: {
                animation: false,
                maintainAspectRatio: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Week View',
                    },
                    tooltip: {
                        mode: 'x'
                    }
                },
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            displayFormats: {
                                day: 'MMM DD'
                            },
                            tooltipFormat: 'YYYY-MM-DD HH:mm',
                            unit: 'day',
                        },
                        min: minDate + 'T00:00:00.000',
                        max: maxDate + 'T23:59:59.999',
                        grid: {
                            offset: false
                        },
                        stacked: true,
                    },
                    y: {
                        beginAtZero: true,
                        position: 'right',
                        ticks: {
                            mirror: true,
                        },
                        stacked: true,
                    }
                }
            }
        });

        this.progressIndicatorService.progress = true;
        forkJoin([
            this.trackingService.getWeekSleepData(this.accountId, maxDate),
        ]).subscribe({
            next: ([data]) => {
                console.log('UserComponentV1.loadSleepWeekData.trackingService.getWeekSleepData.data', data);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                let details = data.flatMap((sleep: any) => sleep.details.map((detail: any) => ({ time: new Date(Date.parse(detail.time)), type: detail.type })))
                    .sort((a: any, b: any) => a.time.getTime() - b.time.getTime());

                let sleepData = [];
                let date = new Date(Date.parse(fromDate));
                date.setDate(date.getDate() - 1);
                let toTime = new Date(Date.parse(toDate)).getTime();
                while (date.getTime() < toTime) {

                    let period = 60;

                    let deepDuration = 0;
                    let lightDuration = 0;
                    let awakeDuration = 0;

                    let i = -1;
                    let j = -1;

                    let min = date.getTime();
                    let max = date.getTime() + (period * 60 * 1000);

                    for (let k = 0; k < details.length; k++) {
                        let t = details[k].time.getTime();
                        if ((t <= min) || (t > min && t < max && i == -1)) {
                            i = k;
                        }
                        if (t >= max) {
                            break;
                        }
                    }

                    for (let k = details.length - 1; k > -1; k--) {
                        let t = details[k].time.getTime();
                        if ((t >= max) || (t > min && t < max && j == -1)) {
                            j = k;
                        }
                        if (t < min) {
                            break;
                        }
                    }

                    if (i > -1 && j > i) {

                        let sub = details.slice(i, j + 1);

                        for (let k = 1; k < sub.length; k++) {

                            let prev = sub[k - 1];
                            let type = sub[k];

                            let start = Math.max(prev.time.getTime(), date.getTime());
                            let end = Math.min(type.time.getTime(), date.getTime() + (period * 60 * 1000));
                            let time = end - start;

                            if (prev.type == 'DEEP') {
                                deepDuration += time;
                            } else if (prev.type == 'LIGHT') {
                                lightDuration += time;
                            } else if (prev.type == 'BEGIN' || prev.type == 'AWAKE') {
                                awakeDuration += time;
                            }
                        }
                    }

                    deepDuration = Math.round(deepDuration / (1000 * 60));
                    lightDuration = Math.round(lightDuration / (1000 * 60));
                    awakeDuration = Math.round(awakeDuration / (1000 * 60));

                    while (deepDuration + lightDuration + awakeDuration > period) {
                        if (deepDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            deepDuration -= 1;
                        } else if (lightDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            lightDuration -= 1;
                        } else if (awakeDuration == Math.max(deepDuration, lightDuration, awakeDuration)) {
                            awakeDuration -= 1;
                        }
                    }

                    sleepData.push({ x: new Date(date), y: { deepDuration: deepDuration, lightDuration: lightDuration, awakeDuration: awakeDuration } });

                    date.setMinutes(date.getMinutes() + period);
                }
                sleepData = sleepData.filter(data => data.y.deepDuration > 0 || data.y.lightDuration > 0 || data.y.awakeDuration > 0);

                this.sleepWeekChart = createChart('sleepWeekChart', sleepData);

            },
            error: (error: any) => {
                console.log('UserComponentV1.loadSleepWeekData.trackingService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    resendWelcomeEmail() {

        this.showModal = null;

        this.progressIndicatorService.progress = true;
        this.userService.resendWelcomeEmail(this.accountId).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.resendWelcomeEmail.userService.resendWelcomeEmail.value', value);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                this.progressIndicatorService.progress = true;
                this.userService.getResendWelcomeEmailUrl(this.account_detail.email).subscribe({
                    next: (value: any) => {
                        console.log('UserComponentV1.resendWelcomeEmail.userService.getResendWelcomeEmailUrl.value', value);
                        this.progressIndicatorService.progress = false;
                        //this.alertService.success('Success');

                        if (value.url) {
                            this.showModal = 'confirm-validate-response';
                            this.confirmValidateUrl = value.url;
                        } else {
                            this.showModal = null;
                            this.alertService.success('Email sent successfully.');
                        }
                    },
                    error: (error: any) => {
                        console.log('UserComponentV1.resendWelcomeEmail.userService.getResendWelcomeEmailUrl.error', error);
                        this.progressIndicatorService.progress = false;
                        //this.alertService.danger('Error');

                        if (error.status == 400) {
                            this.showModal = null;
                            this.alertService.success('Email already validated.');
                        } else {
                            this.showModal = null;
                            this.alertService.success('Email sent successfully.');
                        }
                    }
                });
            },
            error: (error: any) => {
                console.log('UserComponentV1.resendWelcomeEmail.userService.resendWelcomeEmail.error', error);
                this.progressIndicatorService.progress = false;
                //this.alertService.danger('Error');

                if (error.status == 400) {
                    this.showModal = null;
                    this.alertService.success('Email already validated.');
                } else {
                    this.showModal = null;
                    this.alertService.danger('Error');
                }
            }
        });
    }

    resendResetPassword() {

        this.showModal = null;

        this.progressIndicatorService.progress = true;
        this.userService.resendResetPassword(this.account_detail.email).subscribe({
            next: (value: any) => {
                console.log('UserComponentV1.resendResetPassword.userService.resendResetPassword.value', value);
                this.progressIndicatorService.progress = false;
                //this.alertService.success('Success');

                this.progressIndicatorService.progress = true;
                this.userService.getResendResetPasswordUrl(this.accountId).subscribe({
                    next: (value: any) => {
                        console.log('UserComponentV1.resendResetPassword.userService.getResendResetPasswordUrl.value', value);
                        this.progressIndicatorService.progress = false;
                        //this.alertService.success('Success');

                        if (value.url) {
                            this.showModal = 'confirm-reset-response';
                            this.confirmResetUrl = value.url;
                        } else {
                            this.showModal = null;
                            this.alertService.success('Email sent successfully.');
                        }
                    },
                    error: (error: any) => {
                        console.log('UserComponentV1.resendResetPassword.userService.getResendResetPasswordUrl.error', error);
                        this.progressIndicatorService.progress = false;
                        //this.alertService.danger('Error');

                        if (error.status == 400) {
                            this.showModal = null;
                            this.alertService.success('No reset token found for this account.');
                        } else {
                            this.showModal = null;
                            this.alertService.success('Email sent successfully.');
                        }
                    }
                });
            },
            error: (error: any) => {
                console.log('UserComponentV1.resendResetPassword.userService.resendResetPassword.error', error);
                this.progressIndicatorService.progress = false;
                //this.alertService.danger('Error');

                this.showModal = null;
                this.alertService.danger('Error');
            }
        });
    }
}
